import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
export default Object.freeze({
  [FieldTypes.FONT]: {
    size: 'size',
    size_unit: 'size_unit',
    color: 'color',
    styles: 'styles',
    font: 'font',
    underline: 'underline',
    bold: 'bold',
    italic: 'italic'
  },
  [FieldTypes.COLOR]: {
    opacity: 'opacity'
  },
  [FieldTypes.GRADIENT]: {
    direction: 'direction'
  },
  [FieldTypes.BORDER]: {
    color: 'color',
    thickness: 'thickness',
    style: 'style',
    custom_border_sides: 'custom_border_sides'
  },
  [FieldTypes.SPACING]: {
    margin: 'margin',
    padding: 'padding'
  },
  [FieldTypes.TEXT_ALIGNMENT]: {
    LEFT: 'align_left',
    CENTER: 'align_center',
    RIGHT: 'align_right',
    JUSTIFY: 'align_justify'
  },
  [FieldTypes.ALIGNMENT]: {
    LEFT: 'align_left',
    CENTER: 'align_center',
    RIGHT: 'align_right',
    BOTTOM: 'align_bottom',
    MIDDLE: 'align_middle',
    TOP: 'align_top'
  },
  [FieldTypes.BACKGROUND_IMAGE]: {
    position: 'position',
    size: 'size'
  }
});